var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6695_12319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4446 25.5557H20.5557V38.889H29.4446V25.5557Z",
    stroke: "#017848",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.532 15.275L25.7812 0.274283C25.5597 0.09654 25.284 0 24.9999 0C24.7161 0 24.4404 0.0965471 24.2186 0.274283L5.46775 15.275C5.19765 15.4918 5.0294 15.811 5.00345 16.1564C4.97777 16.5021 5.09636 16.8428 5.3313 17.0976C5.56625 17.3523 5.89634 17.498 6.24291 17.5H8.74302V38.7509C8.74302 39.0823 8.87473 39.4004 9.10911 39.6349C9.34349 39.8692 9.66159 40.001 9.99308 40.001H39.9944C40.3259 40.001 40.644 39.8692 40.8783 39.6349C41.1128 39.4004 41.2444 39.0823 41.2444 38.7509V17.5H43.7446C44.0926 17.5013 44.4254 17.3579 44.6628 17.1038C44.9006 16.8496 45.0217 16.5078 44.9968 16.1607C44.972 15.8136 44.8034 15.4927 44.532 15.275ZM39.9944 14.9998C39.663 14.9998 39.3449 15.1316 39.1106 15.3659C38.8761 15.6003 38.7444 15.9184 38.7444 16.2499V37.5008H11.2432V16.2499C11.2432 15.9184 11.1115 15.6003 10.8771 15.3659C10.6428 15.1316 10.3247 14.9998 9.99317 14.9998H9.80566L24.9934 2.84928L40.1812 14.9998H39.9944Z",
    fill: "#017848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6695_12319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.093e508e.svg";
export { ForwardRef as ReactComponent };